import React from 'react';
import PropTypes from 'prop-types';
import BlockContent from '@sanity/block-content-to-react';

import Container from '@components/Container';

import * as styled from './styles';

const CIRCLE_COLORS = {
  orange: '#F36E22',
  teal: '#36B2A3',
  yellow: '#F7B118',
  lilac: '#BB99BB',
};

function CircleChart({ heading, layout, circles }) {
  if (!circles.length) {
    return null;
  }

  return (
    <styled.Wrapper>
      <Container centered>
        <styled.Layout $layout={layout}>
          {heading && (
            <styled.SectionHeading level={200}>{heading}</styled.SectionHeading>
          )}

          <styled.Circles $layout={layout}>
            {circles.map((circle, index) => (
              <styled.Circle
                key={circle._key || index}
                $background={CIRCLE_COLORS[circle.color] || CIRCLE_COLORS.orange}
                $layout={layout}
              >
                <styled.CircleContent>
                  {circle.heading && (
                    <styled.CircleHeading $layout={layout}>{circle.heading}</styled.CircleHeading>
                  )}
                  {Array.isArray(circle.text) && circle.text.length > 0 && (
                    <styled.CircleText $layout={layout}>
                      <BlockContent blocks={circle.text} />
                    </styled.CircleText>
                  )}
                </styled.CircleContent>
              </styled.Circle>
            ))}
          </styled.Circles>
        </styled.Layout>
      </Container>
    </styled.Wrapper>
  );
}

CircleChart.propTypes = {
  heading: PropTypes.string,
  layout: PropTypes.oneOf(['grid', 'row']),
  circles: PropTypes.arrayOf(PropTypes.shape({
    _key: PropTypes.string,
    heading: PropTypes.string,
    color: PropTypes.oneOf(['orange', 'teal', 'yellow', 'lilac']),
    text: PropTypes.array,
  })),
};

CircleChart.defaultProps = {
  heading: null,
  layout: 'grid',
  circles: [],
};

export default CircleChart;
